var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeFiledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00082 16.4167C12.3731 16.4167 15.9177 12.8722 15.9177 8.49985C15.9177 4.1275 12.3731 0.583008 8.00082 0.583008C3.62847 0.583008 0.0839844 4.1275 0.0839844 8.49985C0.0839844 12.8722 3.62847 16.4167 8.00082 16.4167ZM8.79251 5.33311C8.79251 4.89588 8.43807 4.54143 8.00082 4.54143C7.56358 4.54143 7.20914 4.89588 7.20914 5.33311V8.49985C7.20914 8.7098 7.29258 8.91121 7.44102 9.05965L9.42023 11.0389C9.72939 11.348 10.2307 11.348 10.5398 11.0389C10.849 10.7297 10.849 10.2284 10.5398 9.91926L8.79251 8.17193V5.33311Z",
    fill: "#151918",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeFiledIcon);
export default __webpack_public_path__ + "static/media/TimeFiledIcon.a21a878f92f0722cfd85707728a1b237.svg";
export { ForwardRef as ReactComponent };